export class SelectionManager {
  constructor(onChange = () => {}) {
    this.selection = { layerId: null, featureIds: [] }
    this.onChange = onChange
  }

  select(layerId, featureId, { append = false } = {}) {
    const featureIds = append && this.selection.layerId === layerId
      ? [...new Set([...this.selection.featureIds, String(featureId)])]
      : [String(featureId)]
    this.selection = { layerId, featureIds }
    this.onChange(this.selection)
  }

  selectMany(layerId, featureIds) {
    this.selection = { layerId, featureIds: [...new Set(featureIds.map(String))] }
    this.onChange(this.selection)
  }

  clear() {
    this.selection = { layerId: null, featureIds: [] }
    this.onChange(this.selection)
  }
}
